// eslint-disable-next-line max-classes-per-file
import axios from 'axios';
import { sendEvent } from '../../helpers/analytics';

class DeveloperNews {
  constructor() {
    this.node = document.getElementById('developer-news');
    if (!this.node) return;
    this.page = 1;
    this.loading = false;
    this.pagesNode = this.node.querySelector('[data-pages]');
    this.loaderNode = this.node.querySelector('[data-loader]');
    this.pagesCount = Math.ceil(this.node.dataset.totalCount / 6);
  }

  fetch() {
    const { companyId, searchRegionId } = window.params;
    const regionParam = searchRegionId ? `&regionId=${searchRegionId}` : '';
    this.loading = true;
    return axios({
      url: `/api/company/news/${companyId}?page=${this.page}${regionParam}`,
      method: 'post',
      headers: {
        'X-CSRF-Token': window.csrf,
      },
      withCredentials: true,
    });
  }
}

class DeveloperNewsMobile extends DeveloperNews {
  constructor() {
    super();
    if (!this.node) return;
    this.onScroll = this.onScroll.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.attachListeners();
    this.touchStartX = 0;
  }

  attachListeners() {
    this.pagesNode.addEventListener('scroll', this.onScroll);
    this.pagesNode.addEventListener('touchstart', this.onTouchStart);
  }

  onScroll() {
    if (this.loading) return;
    if (this.pagesNode.scrollLeft >= this.pagesNode.scrollWidth - window.screen.width * 2) {
      this.loadPage();
    }
  }

  onTouchStart(e) {
    this.touchStartX = e.changedTouches[0].screenX;
    this.pagesNode.addEventListener('touchend', this.onTouchEnd);
  }

  onTouchEnd(e) {
    const touchEndX = e.changedTouches[0].screenX;
    if (touchEndX > this.touchStartX) { // swipe right
      sendEvent(window.eventCategory, 'news_list', 'swipe_right');
    } else { // swipe left
      sendEvent(window.eventCategory, 'news_list', 'swipe_left');
    }
    this.pagesNode.removeEventListener('touchend', this.onTouchEnd);
  }

  loadPage() {
    if (this.page === this.pagesCount) return;
    this.page += 1;
    const page = this.page;
    this.createLoader();

    this.fetch().then((res) => {
      this.addItems(res.data, page);
      if (page === this.pagesCount) {
        this.pagesNode.removeEventListener('scroll', this.onScroll);
      }
      setTimeout(() => {
        this.loading = false;
      }, 200);
    });
  }

  createLoader() {
    const node = document.createElement('div');
    node.dataset.loading = this.page;
    node.classList.add('UIGrid-col-sm');
    node.classList.add('DeveloperNews-mobile-loader');
    node.innerHTML = this.loaderNode.innerHTML;
    this.pagesNode.appendChild(node);
  }

  addItems(html, page) {
    this.pagesNode.innerHTML += html;
    const loadingNode = this.pagesNode.querySelector(`[data-loading="${page}"]`);
    if (!loadingNode) return;
    loadingNode.remove();
  }
}

class DeveloperNewsDesktop extends DeveloperNews {
  constructor() {
    super();
    if (!this.node) return;
    this.prevArrow = this.node.querySelector('[data-prev]');
    this.nextArrow = this.node.querySelector('[data-next]');
    if (!this.nextArrow && !this.prevArrow) return;

    this.pagesCount = Math.ceil(this.node.dataset.totalCount / 6);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.attachListeners();
  }

  attachListeners() {
    this.prevArrow.addEventListener('click', this.onPrevClick);
    this.nextArrow.addEventListener('click', this.onNextClick);
  }

  loadPage() {
    // Check if page is already exists
    if (this.pagesNode.querySelector(`[data-page="${this.page}"]`)) {
      this.slideToCurrentPage();
      return;
    }

    this.createLoaderPage();
    this.slideToCurrentPage();

    this.fetch().then((res) => {
      this.createPage(res.data);
    });
  }

  onNextClick() {
    if (this.nextArrow.classList.contains('-disabled')) return;
    this.page += 1;
    this.prevArrow.classList.remove('-disabled');
    if (this.page >= this.pagesCount) {
      this.nextArrow.classList.add('-disabled');
    }

    this.loadPage();
  }

  onPrevClick() {
    if (this.prevArrow.classList.contains('-disabled')) return;
    this.page -= 1;
    this.nextArrow.classList.remove('-disabled');
    if (this.page === 1) {
      this.prevArrow.classList.add('-disabled');
    }
    this.loadPage();
  }

  createPage(html) {
    const containerNode = this.pagesNode.querySelector(`[data-page="${this.page}"]`);
    containerNode.innerHTML = html;
  }

  createLoaderPage() {
    const pageNode = document.createElement('div');
    pageNode.dataset.page = this.page;
    pageNode.classList = 'DeveloperNews-page';
    pageNode.innerHTML = this.loaderNode.innerHTML;
    const nextPage = this.pagesNode.querySelector(`[data-page="${this.page + 1}"]`);
    if (nextPage) {
      this.pagesNode.insertBefore(pageNode, nextPage);
    } else {
      this.pagesNode.appendChild(pageNode);
    }
  }

  slideToCurrentPage() {
    const currentPage = this.pagesNode.querySelector(`[data-page="${this.page}"]`);
    this.pagesNode.style.transform = `translateX(${-1 * currentPage.offsetLeft}px)`;
  }
}

const init = () => {
  if (window.isMobile) {
    new DeveloperNewsMobile();
  } else {
    new DeveloperNewsDesktop();
  }
};

init();
